if (!customElements.get('m3015-gallery')) {
  customElements.define('m3015-gallery', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.initialize());
    }
    initialize() {
      if (!this.isConnected || this.controller) return;
      this.track = this.querySelector('.m3015-track');
      this.progress = this.querySelector('.m3015-progress');
      if (!this.track || !this.progress) return;
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.mobile = matchMedia('(max-width:749px)');
      this.index = 0;
      this.rebuild();
      this.mobile.addEventListener('change', () => this.go(this.index), options);
      this.track.addEventListener('scroll', () => {
        if (!this.mobile.matches) return;
        const left = this.track.getBoundingClientRect().left;
        this.index = this.slides.reduce((best, item, i) => Math.abs(item.getBoundingClientRect().left-left) < Math.abs(this.slides[best].getBoundingClientRect().left-left) ? i : best, 0);
        this.update();
      }, {...options,passive:true});
      this.progress.addEventListener('click', event => {
        const button=event.target.closest('button[data-slide]');
        if(button) this.go(Number(button.dataset.slide));
      },options);
      this.track.addEventListener('keydown',event=>{
        if(!this.mobile.matches || event.target!==this.track) return;
        if(event.key==='ArrowRight'||event.key==='ArrowLeft'){
          event.preventDefault();this.go(this.index+(event.key==='ArrowRight'?1:-1));
        }
      },options);
      this.addEventListener('shopify:block:select',event=>{
        const index=this.slides.findIndex(item=>item.dataset.blockId===event.detail.blockId);
        if(index>=0)this.go(index);
      },options);
      this.resize=new ResizeObserver(()=>this.go(this.index));this.resize.observe(this.track);
      this.mutation=new MutationObserver(()=>this.rebuild());this.mutation.observe(this.track,{childList:true});
    }
    rebuild(){
      this.slides=Array.from(this.track.children);this.progress.replaceChildren();
      this.slides.forEach((slide,i)=>{
        const button=document.createElement('button');button.type='button';button.dataset.slide=i;
        button.setAttribute('aria-label',`${i+1} / ${this.slides.length}`);button.setAttribute('aria-controls',this.track.id);this.progress.append(button);
      });this.go(this.index);
    }
    go(index){
      this.index=Math.max(0,Math.min(index,this.slides.length-1));
      this.progress.hidden=!this.mobile.matches||this.slides.length<2;
      this.track.tabIndex=this.mobile.matches&&this.slides.length>1?0:-1;
      const slide=this.slides[this.index];
      const left=slide?slide.getBoundingClientRect().left-this.track.getBoundingClientRect().left+this.track.scrollLeft:0;
      this.track.scrollTo({left:this.mobile.matches?left:0,behavior:'instant'});this.update();
    }
    update(){Array.from(this.progress.children).forEach((button,i)=>button.setAttribute('aria-current',String(i===this.index)));}
    disconnectedCallback(){cancelAnimationFrame(this.frame);this.controller?.abort();this.resize?.disconnect();this.mutation?.disconnect();this.controller=null;}
  });
}
